// /**
//  * Orders - list
//  */

// React
import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import HeaderBuilder from '../../../utils/headerBuilder';
// Context
import AuthContext from '../../../authContext';

// UI
import theme from '../../../theme';
import clsx from 'clsx';
import {
  createStyles,
  makeStyles,
  Theme,
  withStyles,
  lighten,
} from '@material-ui/core/styles';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  Paper,
  IconButton,
  Button,
  Typography,
  Tooltip,
  Toolbar,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@material-ui/core';

// Icon
import Icon from '@mdi/react';
import {
  mdiFileDocumentOutline,
  mdiHistory,
  mdiChevronDown,
  mdiChevronUp,
  mdiFileTree,
} from '@mdi/js';

// Components
import Can from '../../../components/Can';

// Helper
import {
  translate,
  checkMatchMedia,
} from '../../../utils/helpers';
import jMoment from 'moment-jalaali';

// Type
import { Order } from './interfaces';

type Data = Order;
type Props = {
  data: any;
  changeStatusOrderWhitId: any;
  handleOpenConfirmUpdateState: any;
};
type Ord = 'asc' | 'desc';

interface HeadCell {
  id: keyof Data;
  label: string;
}

interface EnhancedTableProps {
  classes: ReturnType<typeof useStyles>;
  onRequestSort: (
    event: React.MouseEvent<unknown>,
    property: keyof Data
  ) => void;
  order: Ord;
  orderBy: string;
  rowCount: number;
  numSelected: number;
  onSelectAllClick: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

// Style
const StyledTableCell = withStyles((theme: Theme) =>
  createStyles({
    head: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      '@media (max-width: 768px)': {
        fontSize: 10,
      },
    },
    body: {
      fontSize: 14,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  })
)(TableCell);
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
      '& .MuiTableCell-root': {
        padding: '5px',
      },
    },
    paper: {
      width: '100%',
    },
    table: {
      // minWidth: 750,
    },
    head: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
    },
    columnText: {
      padding: '0 10px',
    },
    visuallyHidden: {
      border: 0,
      clip: 'rect(0 0 0 0)',
      height: 1,
      margin: -1,
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      top: 20,
      width: 1,
    },
    container: {
      maxHeight: 650,
      borderRadius: '4px',
    },
    // Fully visible for active icons
    activeSortIcon: {
      opacity: 1,
      color: `${theme.palette.secondary.main}!important`,
    },
    // Half visible for inactive icons
    inactiveSortIcon: {
      opacity: 0.4,
    },
    iconButton: {
      padding: 10,
      position: 'relative',
      '&:before': {
        content: '""',
        position: 'absolute',
        width: '1px',
        height: '36px',
        top: '4px',
        left: '-9px',
        backgroundColor: '#EDF1F4',
      },
    },
    changStatusIcon: {
      marginRight: '10px',
      position: 'absolute',
    },
    changStatusBox: {
      display: 'flex',
      textAlign: 'left',

      fontWeight: 400,
      fontSize: '14px',
    },
    renderValue: {
      paddingLeft: '32px',
    },
    radioGroup: {
      margin: '-8px 0',
    },
    radioGroupItem: {
      borderBottom: '1px solid #D8D8D8',
      marginRight: '-8px',
      padding: '8px 16px',
      '&:last-child': {
        borderBottom: '0px',
      },
    },
  })
);

const useToolbarStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(1),
      marginBottom: theme.spacing(1),
      justifyContent: 'space-between',
    },
    highlight:
      theme.palette.type === 'light'
        ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
        : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
    title: {
      // flex: '1 1 100%',
    },
  })
);

interface EnhancedTableToolbarProps {
  numSelected: number;
  setOpenChangeStatus: any;
  selected: any;
  data: any;
}

const EnhancedTableToolbar = (props: EnhancedTableToolbarProps) => {
  const classes = useToolbarStyles();
  const [openAlertWarning, setOpenAlertWarning] = useState(false as boolean);
  const { numSelected, selected, data } = props;

  const handleClickChangeStatus = () => {
    const selectedData = data.filter(
      (item: any) => selected.indexOf(item.id) > -1
    );

    if (!checkStatus(selectedData)) {
      setOpenAlertWarning(true);
    } else {
      props.setOpenChangeStatus(true);
    }
  };

  const checkStatus = (data: any) => {
    let sameStatus = true;
    data?.map((item: any) => {
      if (item?.status !== data[0]?.status) {
        return (sameStatus = false);
      }
      return item;
    });
    return sameStatus;
  };

  return (
    <>
      {numSelected > 0 && (
        <Toolbar
          className={clsx(classes.root, {
            [classes.highlight]: numSelected > 0,
          })}
        >
          {numSelected > 0 ? (
            <Typography
              className={classes.title}
              color="inherit"
              variant="subtitle1"
              component="div"
            >
              {numSelected} انتخاب
            </Typography>
          ) : (
            <Typography
              className={classes.title}
              variant="h6"
              id="tableTitle"
              component="div"
            />
          )}
          {numSelected > 0 && (
            <Tooltip title="تغییر وضعیت">
              <Button
                size="small"
                variant="contained"
                onClick={handleClickChangeStatus}
                color="secondary"
              >
                تغییر وضعیت
              </Button>
            </Tooltip>
          )}
        </Toolbar>
      )}
      <Dialog
        fullWidth
        open={openAlertWarning}
        onClose={() => setOpenAlertWarning(false)}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>امکان تغییر وضعیت سفارش وجود ندارد </DialogTitle>
        <DialogContent>
          وضعیت سفارش آیتم‌های انتخاب شده باید یکی باشد
        </DialogContent>
        <DialogActions>
          <Button
            autoFocus
            onClick={() => setOpenAlertWarning(false)}
            variant="contained"
            color="primary"
          >
            {'متوجه شدم'}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

function descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator<Key extends keyof any>(
  order: Ord,
  orderBy: Key
): (
    a: { [key in Key]: number | string },
    b: { [key in Key]: number | string }
  ) => number {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort<T>(array: T[], comparator: (a: T, b: T) => number) {
  const stabilizedThis = array.map((el, index) => [el, index] as [T, number]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
}

function EnhancedTableHead(props: EnhancedTableProps) {
  const authContext = useContext(AuthContext);
  const classes = useStyles();
  const { order, orderBy, onRequestSort } = props;
  const createSortHandler = (property: keyof Data) => (
    event: React.MouseEvent<unknown>
  ) => {
    onRequestSort(event, property);
  };
  let headCells: HeadCell[] = [];

  Can({
    role: authContext.user.role,
    perform: 'orders:tracking-code',
    yes: () => {
      headCells = [
        { id: 'orderId', label: 'شناسه سفارش' },
        {
          id: 'unLocateItemsCount',
          label: 'تعداد آیتم های سفارش',
        },
        {
          id: 'itemsCount',
          label: 'تعداد آیتم ها',
        },
        {
          id: 'orderLastStatus',
          label: 'وضعیت قبلی',
        },
        {
          id: 'created',
          label: 'تاریخ ایجاد',
        },
        { id: 'status', label: 'وضعیت' },
      ];
    },
    no: () => {
      headCells = [
        { id: 'orderId', label: 'شناسه سفارش' },
        {
          id: 'unLocateItemsCount',
          label: 'تعداد آیتم های سفارش',
        },
        {
          id: 'itemsCount',
          label: 'تعداد آیتم ها',
        },
        {
          id: 'orderLastStatus',
          label: 'وضعیت قبلی',
        },
        {
          id: 'created',
          label: 'تاریخ ایجاد',
        },
        { id: 'status', label: 'وضعیت' },
      ];
    },
  });

  return (
    <TableHead>
      <TableRow>
        {headCells.map(headCell => (
          <StyledTableCell
            key={headCell.id}
            align="center"
            sortDirection={orderBy === headCell.id ? order : false}
            data-cy={headCell.id}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
              classes={{
                // Override with the active class if this is the selected column or inactive otherwise
                icon:
                  orderBy === headCell.id
                    ? classes.activeSortIcon
                    : classes.inactiveSortIcon,
              }}
              IconComponent={() => (
                <Icon
                  path={
                    orderBy === headCell.id && order === 'desc'
                      ? mdiChevronDown
                      : mdiChevronUp
                  }
                  size={0.7}
                  className={
                    orderBy === headCell.id
                      ? classes.activeSortIcon
                      : classes.inactiveSortIcon
                  }
                />
              )}
            >
              <span className={classes.columnText}>{headCell.label}</span>
            </TableSortLabel>
          </StyledTableCell>
        ))}
        <StyledTableCell />
      </TableRow>
    </TableHead>
  );
}

export default function EnhancedTable(props: Props) {
  const authContext = useContext(AuthContext);
  const classes = useStyles();

  const [order, setOrder] = React.useState<Ord>('desc');
  const [orderBy, setOrderBy] = React.useState<keyof Data>('id');
  const [selected, setSelected] = React.useState<string[]>([]);
  const [valueStatus, setValueStatus] = React.useState('');
  const [openChangeStatus, setOpenChangeStatus] = React.useState(false);
  const handleChangeValueStatus = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setValueStatus((event.target as HTMLInputElement).value);
  };
  const handleRequestSort = (
    event: React.MouseEvent<unknown>,
    property: keyof Data
  ) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      const newSelecteds = props.data.map((n: any) => n.id);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  return (
    <div className={classes.root}>
      <EnhancedTableToolbar
        numSelected={selected.length}
        setOpenChangeStatus={setOpenChangeStatus}
        selected={selected}
        data={props.data}
      />
      <Paper className={classes.paper}>
        <TableContainer className={classes.container}>
          <Table
            stickyHeader
            className={classes.table}
            aria-labelledby="tableTitle"
            size={checkMatchMedia('(max-width: 1024px)') ? 'small' : 'medium'}
            aria-label="enhanced table"
          >
            <HeaderBuilder
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
              rowCount={props.data.length}
              numSelected={selected.length}
              onSelectAllClick={handleSelectAllClick}
              filterVal={props.filterVal}
              onFilterValue={(filtervalues: any) => {
                props.onFilterValue(filtervalues);
              }}
              head={props.head}
              removeFilterHandler={props.removeFilterHandler}
              haveAction={true}
              filterLabelTranslator={props.filterLabelTranslator}
            />

            <TableBody>
              {stableSort(props.data, getComparator(order, orderBy))
                .slice()
                .map((row: any, index: number) => {
                  const labelId = `enhanced-table-checkbox-${index}`;
                  return (
                    <TableRow key={index} hover role="checkbox" tabIndex={-1}>
                      <StyledTableCell id={labelId} scope="row" align="center">
                        {row.orderId}
                      </StyledTableCell>
                      <StyledTableCell id={labelId} scope="row" align="center">
                        {row.unLocateItemsCount}
                      </StyledTableCell>
                      <StyledTableCell id={labelId} scope="row" align="center">
                        {row.itemsCount}
                      </StyledTableCell>

                      <StyledTableCell align="center">
                        <span>{translate(row.orderLastStatus, 'order')}</span>
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <span>
                          {jMoment(row.created, 'YYYY/M/D')
                            .locale('fa')
                            .format('jYY/jMM/jDD')}
                        </span>
                      </StyledTableCell>
                      <StyledTableCell id={labelId} scope="row" align="center">
                        {translate(row.status, 'bundle')}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {translate(row.paymentType, 'bundle')}
                      </StyledTableCell>
                      <StyledTableCell align="right">
                        <div>
                          {row.status === 'ASSIGNED' ? (
                            <Link
                              to={`/order/${row.orderId}/cancellation/${row.id}/locate-inventory-items`}
                            >
                              <IconButton
                                aria-label="details"
                                size="small"
                                title="جای گذاری محموله"
                                data-cy="details"
                              >
                                <Icon
                                  path={mdiFileTree}
                                  size={1}
                                  color="purple"
                                />
                              </IconButton>
                            </Link>
                          ) : null}
                          <Link to={`/orders/${row.orderId}`}>
                            <IconButton
                              aria-label="details"
                              size="small"
                              title="جزئیات سفارش"
                              data-cy="details"
                            >
                              <Icon
                                path={mdiFileDocumentOutline}
                                size={1}
                                color={theme.palette.green.main}
                              />
                            </IconButton>
                          </Link>
                          <Can
                            role={authContext.user.role}
                            perform="orders:history"
                            yes={() => (
                              <Link to={`/orders/${row.orderId}/alllogs`}>
                                <IconButton size="small" title="تاریخچه سفارش">
                                  <Icon path={mdiHistory} size={1} />
                                </IconButton>
                              </Link>
                            )}
                          />
                        </div>
                      </StyledTableCell>
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </div>
  );
}
